<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>منهج المشروع</h2>
        </div>
    </div>
</div>


<div class="service-details ptb-100">
    <div class="container">
      
        <div class="service-details-content">

            <div class="row">
                
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        اولا : مخرج الجوف ( خلاء الحلق والفم ) - برنامج الاتقان لتلاوة القران .

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/GMFVSOef0Zs?si=mog0rzOGYc9kuGh_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        ثانيا : الحلق ( الهمزة والهاء ، العين والحاء ، الغين والخاء) من برنامج الاتقان لتلاوة القران .

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/xqQkxf6XMQU?si=n6qT6iBwMfK27p4X" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        ثالثا : مخارج اللسان ج1 :وفيه : (1)- القاف (2)- الكاف (3)- الجيم والشين والياء-- برنامج الاتقان

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/x34n0Q4UTS0?si=ajdWi0NiAUO80vjg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        ثالثا : مخارج اللسان (ج2 ) وفيه حرف (الضاد) وما يتعلق به من تنبيهات - برنامج الاتقان لتلاوة القران

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/SPIGcLthkw8?si=1vaCTZvQbVRHClKg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        ثالثا : مخارج اللسان ج ( 3 ) وفيه مخرج اللام والنون - برنامج الاتقان لتلاوة القران

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/XjFhuOKf6R8?si=Y5bsrPm3jUXNME_U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        ثالثا : مخارج اللسان ج ( 4) وفيه مخرج الراء مع صفة التكرير - برنامج الاتقان لتلاوة القران

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/RSlTUI2LVrA?si=gipzlvOaGfOrmNRH" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        ثالثا : مخارج اللسان ج (5) وفيه حروف( ط- د- ت ) وحروف الصفير ( ص-س-ز) - الاتقان لتلاوة القران

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/RtmaHJJRIRA?si=Dj6XoBhrXqj61vzy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        ثالثا: مخارج اللسان ج (6) والاخير وفيه حروف ( الظاء والذال والثاء ) برنامج الاتقان لتلاوة القران

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/ENNWHEybzrs?si=nTDSY1ZutfaTFIFZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        رابعا : مخرج الشفتين وفيه حروف ( الفاء - الباء - الواو- الميم ) برنامج الاتقان لتلاوة القران

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/oiC2zg0Zpek?si=ViUdMqs7TsaLtWly" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        خامسا : مخرج الخيشوم (المخرج الاخيرمن من مخارج الحروف) - برنامج الاتقان لتلاوة القران

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/FUbBrsqy4vI?si=jFMvZnsuRrplGc5X" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                

            </div>

            </div>
    </div>
</div>


